import { Center } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey } from '@fortawesome/pro-regular-svg-icons';

const MfaTotpIcon = () => (
  <>
    <Center
      width={'2em'}
      height={'2em'}
      borderRadius={'full'}
      color={'white'}
      bgColor={'cyan.300'}
      _dark={{ bgColor: 'cyan.600' }}
    >
      <FontAwesomeIcon icon={faKey} fixedWidth />
    </Center>
  </>
);

export default MfaTotpIcon;
